import React, {useState, useEffect} from 'react';
import {
  DialogContentText,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  colors,
  Button,
  Snackbar,
  CircularProgress,
} from '@material-ui/core';

import validate from 'validate.js';

import {DropzoneArea} from 'material-ui-dropzone'
import MuiAlert from '@material-ui/lab/Alert';

import { postCompanyAPIReq } from "utils/requests"
import PropTypes from "prop-types";
import MyOffers from "../../../../MyOffers";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const schema = {
  name: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 64
    }
  },
  industry: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  },
  website: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  },
  location: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  }
};

const CreateCompany = (props) => {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState('');
  const [image, setImage] = React.useState([])
  const [openSnack, setOpenSnack] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [severity, setSeverity] = React.useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSnack = (message, severity) => {
    setMessage(message)
    setSeverity(severity)
    setOpenSnack(true);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const handleLoading = () => {
    if (!loading) {
      setLoading(true);
    } else if (loading) {
      setLoading(false)
    }
  };

  const handleChange = (event) => {
    // setValue(event.target.value);

    // event.persist();

    // setFormState(formState => ({
    //   ...formState,
    //   values: {
    //     ...formState.values,
    //     [event.target.name]:
    //       event.target.type === 'checkbox'
    //         ? event.target.checked
    //         : event.target.value
    //   },
    //   touched: {
    //     ...formState.touched,
    //     [event.target.name]: true
    //   }
    // }));
     event.persist();

    if(event.target.value.match(/^[a-zA-Z0-9\s._èéêàá?!\[\]();,-]*$/)) {
      setFormState(formState => ({
        ...formState,
        values: {
          ...formState.values,
          [event.target.name]:
            event.target.type === 'checkbox'
              ? event.target.checked
              : event.target.value
        },
        touched: {
          ...formState.touched,
          [event.target.name]: true
        }
      }));
    }
  };

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      name: "",
      location: "",
      website: "",
      industry: "",
    },
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  function handleSubmit(event) {
    // console.log(props)
    setLoading(true)
    // console.log(image)
    event.preventDefault();
    return postCompanyAPIReq(formState.values, image)
      .then(res=>{
        if (res.error) {
          setLoading(false)
          props.handleModalData('An error occurred (' + res.error.code + ':' + res.error.message +  ')', 'error')
          handleClose()
        } else {
          // console.log(res)
          setLoading(false)
          props.handleModalData('Your company has been created, you can find it in the list', 'success')
          handleClose()
        }
      }).catch((err) => {
        setLoading(false)
        console.error(err)
        handleClose()
      })
  }

  const onPictureFileChange = (files) => {
    setImage(files[0])
  };

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <div>
    <Button variant="contained" color="primary" onClick={handleClickOpen}>
        ADD NEW COMPANY
      </Button>
    <Dialog
      open={open}
      onClose={() => props}
      aria-labelledby="confirm-dialog"
    >
       <DialogTitle id="form-dialog-title">Add a company</DialogTitle>
        <DialogContent>
          <Card
          >
            <form
              autoComplete="off"
              noValidate
              onSubmit={handleSubmit}
            >
              <CardHeader
                subheader="Thank you for contributing to our DB"
                title="Add a new company"
              />
              <Divider />
              <CardContent>
                <Grid
                  container
                  spacing={3}
                >
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      helperText="Please specify the offer title"
                      label="Company name"
                      margin="dense"
                      name="name"
                      required
                      onChange={handleChange}
                      error={hasError('name')}
                      helperText={
                        hasError('name') ? formState.errors.name[0] : null
                      }
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Industry"
                      margin="dense"
                      name="industry"
                      onChange={handleChange}
                      required
                      error={hasError('industry')}
                      helperText={
                        hasError('industry') ? formState.errors.industry[0] : null
                      }
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Website"
                      margin="dense"
                      name="website"
                      onChange={handleChange}
                      required
                      error={hasError('website')}
                      helperText={
                        hasError('website') ? formState.errors.website[0] : null
                      }
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Location (Headquarters)"
                      margin="dense"
                      name="location"
                      onChange={handleChange}
                      error={hasError('location')}
                      helperText={
                        hasError('location') ? formState.errors.location[0] : null
                      }
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                     <DropzoneArea
                        onChange={onPictureFileChange}
                        filesLimit={1}
                        dropzoneText="Drop a company image/banner"
                        showPreviewsInDropzone={true}
                        acceptedFiles={['image/jpeg', 'image/png']}
                        name="image"
                        />

                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
            </form>
          </Card>
        </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => setOpen(false)}
          color="white"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          type='submit'
          disabled={loading || !formState.isValid}
          onClick={
            handleSubmit
          }
          color="primary"
        >
          Create
        </Button>
        {loading && <CircularProgress size={24} />}
      </DialogActions>
    </Dialog>
    </div>
  );
};

export default CreateCompany;
